// AuthGate — wrapper de rotas que exige sessão.
// Se não autenticado, redireciona pra /login.

import { Navigate, useLocation } from "react-router-dom";
import { useSession } from "../lib/auth";
import { Skeleton } from "./ui/Skeleton";

interface AuthGateProps {
  children: React.ReactNode;
}

export const AuthGate = ({ children }: AuthGateProps) => {
  const session = useSession();
  const location = useLocation();

  if (session.isLoading) {
    return (
      <div
        role="status"
        aria-label="Carregando"
        className="flex flex-col items-center justify-center min-h-[400px] gap-3"
      >
        <Skeleton className="h-4 w-32" />
        <Skeleton className="h-3 w-24" />
      </div>
    );
  }

  if (!session.isAuthenticated) {
    const returnTo = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?returnTo=${returnTo}`} replace />;
  }

  return <>{children}</>;
};
